import { render } from "./CreateBrandModal.vue?vue&type=template&id=c925892a&scoped=true&ts=true"
import script from "./CreateBrandModal.vue?vue&type=script&lang=ts"
export * from "./CreateBrandModal.vue?vue&type=script&lang=ts"

import "./CreateBrandModal.vue?vue&type=style&index=0&id=c925892a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c925892a"]])

export default __exports__